<script setup lang="ts">
import { useChatStore } from '@/stores/chat'

const chatStore = useChatStore()
</script>

<template>
  <div class="bg-white border-b border-gray-100 px-4 py-2">
    <div class="flex items-center gap-3">
      <div class="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
        <div
          class="h-full bg-primary transition-all duration-500 ease-out rounded-full"
          :style="{ width: `${chatStore.progressPercent}%` }"
        />
      </div>
      <span class="text-xs text-gray-500 font-medium min-w-[3rem] text-right">
        {{ chatStore.progressPercent }}%
      </span>
    </div>
  </div>
</template>
